export const TENANT_TYPE_COMBINATIONS = [
    { tenant: 'vista', type: 'merchants' },
    { tenant: 'vista', type: 'services' },
    { tenant: 'vistaprint', type: 'merchants' },
    { tenant: 'vistaprint', type: 'services' },
    { tenant: 'pixart', type: 'merchants' },
    { tenant: 'pixart', type: 'services' },
    { tenant: 'cimpress', type: 'merchants' },
    { tenant: 'cimpress', type: 'services' },
    { tenant: 'visualization-demo', type: 'merchants' },
    { tenant: 'SceneTestGroup', type: 'merchants' },
];
